export var VERSION = '1.3.5';
//# sourceMappingURL=version.js.map